<template>
    <div class="e-card e-rounding shadow-sm">
      <PremiumBanner/>
      <h1 class="h3">{{ $t('title.userManagementInfo') }}</h1>

      <Loader v-if="loading" />        
      
        <div class="d-flex mb-2 justify-content-md-end justify-content-center" v-if="!loading">
          <button @click="prepareAddUser()" class="btn btn-primary m-2">
            <i class="fas fa-plus pr-1"></i> {{ $t('button.addUser') }}
          </button>
        </div>

        <div v-if="!loading" class="row">
          <div class="col-12 col-lg-6 mt-2 mb-2" v-for="user in users" v-bind:key="user.userId">
            <div class="user-card shadow-sm e-rounding" :class="{ 'user-card--inactive': user.role === 'none' }">

              <!-- Banner -->
              <div class="user-card__banner" :class="{ 'user-card__banner--inactive': user.role === 'none', 'user-card__banner--admin': user.role === 'admin' }">
                <div class="user-card__role-icon" v-html="roleIconSvg(user.role)"></div>
                <div class="user-card__banner-text">
                  <div class="user-card__role-label">{{ getRoleName(user.role) }}</div>
                  <div class="user-card__name">{{ user.userName }}</div>
                  <div class="user-card__badges">
                    <span v-if="user.emailNotConfirmed !== null" class="badge badge-warning" v-tooltip="$t('tooltip.emailNotConfirmed')">
                      <i class="fa-solid fa-triangle-exclamation mr-1"></i>{{ $t('form.user.emailNotConfirmed') }}
                    </span>
                  </div>
                </div>
              </div>

              <!-- Info grid -->
              <div class="user-card__body">
                <div class="user-card__grid">
                  <div class="user-card__field user-card__field--wide" v-if="user.emailConfirmed !== null">
                    <div class="user-card__label">{{ $t('form.user.email') }}</div>
                    <div class="user-card__value">{{ user.emailConfirmed }}</div>
                  </div>
                  <div class="user-card__field user-card__field--wide" v-if="user.emailNotConfirmed !== null">
                    <div class="user-card__label">{{ $t('form.user.email') }}</div>
                    <div class="user-card__value">{{ user.emailNotConfirmed }}</div>
                  </div>
                </div>

                <!-- Actions -->
                <div class="user-card__actions">
                  <button @click="prepareEditUser(user.userId)" class="btn btn-secondary btn-sm">
                    <i class="fas fa-pen mr-1"></i>{{ $t('button.editUser') }}
                  </button>
                </div>
              </div>

            </div>
          </div>
      </div>

      <div class="e-card-backdrop" v-if="!loading && showUser">
        <div class="row e-modal-row justify-content-center align-items-start">
          <div class="e-modal-card col-10 col-lg-6 bg-white shadow-sm e-rounding p-0">
            <div class="card-header e-user__header" v-bind:class="{ 'e-not-active': user.role==='none',user_admin: user.role ==='admin' }">
              <span v-if="user.userId !== null">{{ $t('button.editUser') }}</span>
              <span v-if="user.userId === null">{{ $t('button.addUser') }}</span>
              <i @click="showUser = false" class="fas fa-times e-modal-close-icon"></i>
            </div>
            <div class="card-body py-5 px-4">
              <form>
                <div class="form-group mb-4">
                  <label for="userName">{{ $t('form.user.userName') }}</label> <i v-show="user.userId === null" v-tooltip="$t('tooltip.user.username')" class="far fa-question-circle"></i>
                  <input v-model="user.userName" class="form-control" id="userName" :disabled="user.userId !== null">
                </div>
                <div class="form-group mb-4">
                  <label for="email">{{ $t('form.user.email') }}</label> <i v-show="user.userId === null" v-tooltip="$t('tooltip.user.email')" class="far fa-question-circle"></i>
                  <input v-model="user.email" class="form-control" id="email">
                </div>
                <div class="form-group mb-4">
                  <label for="role">{{ $t('form.user.role') }}</label> <i v-tooltip="$t('tooltip.user.role')" class="far fa-question-circle"></i>
                  <select v-model="user.role" class="form-control" id="role" @change="readRoleRights(user.role)">
                    <option v-for="r in user.userId === null?rolesCreate:roles" v-bind:value="r"
                            v-bind:key="r">
                      {{ getRoleName(r) }}
                    </option>
                  </select>
                </div>


                <div v-if="user.role === 'custom'" >
                  <div style="margin: 10px; color: #04084c">{{ $t('rights.customInfoApp')}}</div>
                  <div class="d-flex flex-wrap-reverse ">
                  <div class="col-12 col-lg-6 mt-2 mb-2">
                    <div class="e-inner-card shadow-sm e-rounding">
                      <div class="card-header e-user__header">
                        <span>
                    {{ $t('rights.cashRegister') }}
                  </span>
                      </div>
                      <div class="card-body py-5 px-4">
                        <RightSetting :right-id="rc.shiftSales" :right-model="user.rights" @changeRight="rightChanged($event)"></RightSetting>
                        <RightSetting :right-id="rc.allSales" :right-model="user.rights" @changeRight="rightChanged($event)"></RightSetting>
                        <p></p>
                        <RightSetting :edit="true" :right-id="rc.deleteReceipt" :right-model="user.rights" @changeRight="rightChanged($event)"></RightSetting>
                        <RightSetting :edit="true" :right-id="rc.createNegativeReceipt" :right-model="user.rights" @changeRight="rightChanged($event)"></RightSetting>
                        <RightSetting :edit="true" :right-id="rc.updateBill" :right-model="user.rights" @changeRight="rightChanged($event)"></RightSetting>
                        <RightSetting :edit="true" :right-id="rc.addDiscount" :right-model="user.rights" @changeRight="rightChanged($event)"></RightSetting>
                        <RightSetting :edit="true" :right-id="rc.orders" :right-model="user.rights" @changeRight="rightChanged($event)"></RightSetting>
                        <RightSetting :edit="true" :right-id="rc.stock" :right-model="user.rights" @changeRight="rightChanged($event)"></RightSetting>
                        <RightSetting :edit="true" :right-id="rc.createCustomer" :right-model="user.rights" @changeRight="rightChanged($event)"></RightSetting>
                        <RightSetting :edit="true" :right-id="rc.updateCustomer" :right-model="user.rights" @changeRight="rightChanged($event)"></RightSetting>
                        <RightSetting :edit="true" :right-id="rc.updateReceipt" :right-model="user.rights" @changeRight="rightChanged($event)"></RightSetting>
                        <p></p>
                        <RightSetting :edit="true" :right-id="rc.cashRegisterSettings" :right-model="user.rights" @changeRight="rightChanged($event)"></RightSetting>
                        <RightSetting :edit="true" :right-id="rc.salesItem" :right-model="user.rights" @changeRight="rightChanged($event)"></RightSetting>
                        <RightSetting :edit="true" :right-id="rc.companySettings" :right-model="user.rights" @changeRight="rightChanged($event)"></RightSetting>
                      </div>
                    </div>
                  </div>
                  <div class="mb-4"></div>
                  <div class="col-12 col-lg-6 mt-2 mb-2">
                    <div class="e-inner-card shadow-sm e-rounding">
                      <div class="card-header e-user__header">
                        <span>
                     {{ $t('rights.office') }}
                  </span>
                      </div>
                      <div class="card-body py-5 px-4">
                        <RightSetting :right-id="rc.allReceipts" :right-model="user.rights" @changeRight="rightChanged($event)"></RightSetting>
                        <RightSetting :right-id="rc.allSales" :right-model="user.rights" @changeRight="rightChanged($event)"></RightSetting>
                        <RightSetting :right-id="rc.exportSales" :right-model="user.rights" @changeRight="rightChanged($event)"></RightSetting>
                        <RightSetting :right-id="rc.allSubjects" :right-model="user.rights" @changeRight="rightChanged($event)"></RightSetting>
                        <p></p>
                        <RightSetting :edit="true" :right-id="rc.orders" :right-model="user.rights" @changeRight="rightChanged($event)"></RightSetting>
                        <RightSetting :edit="true" :right-id="rc.stock" :right-model="user.rights" @changeRight="rightChanged($event)"></RightSetting>
                        <RightSetting :edit="true" :right-id="rc.salesItem" :right-model="user.rights" @changeRight="rightChanged($event)"></RightSetting>
                        <RightSetting :edit="true" :right-id="rc.companySettings" :right-model="user.rights" @changeRight="rightChanged($event)"></RightSetting>
                        <RightSetting :edit="true" :right-id="rc.loyaltyPoints" :right-model="user.rights" @changeRight="rightChanged($event)"></RightSetting>
                      </div>
                    </div>
                  </div>
                  </div>
                </div>

                <div v-if="user.role !== 'custom' && user.role !=='none'" class="form-group mb-4">
                  <div v-if="!showRightDetails"><a href="#" @click="showRightDetails=true">{{ $t('rights.showDetail') }}</a></div>
                  <div v-if="showRightDetails">
                    <div v-if="showRightDetails"><a href="#" @click="showRightDetails=false">{{ $t('rights.hideDetail') }}</a></div>

                    <div class="d-flex flex-wrap-reverse ">
                      <div class="col-12 col-lg-6 mt-2 mb-2">
                        <div class="e-inner-card shadow-sm e-rounding">
                          <div class="card-header e-user__header">
                        <span>
                    {{ $t('rights.cashRegister') }}
                  </span>
                          </div>
                          <div class="card-body py-5 px-4">
                            <RightSetting :right-id="rc.shiftSales" :right-model="roleRights" disabled="true"></RightSetting>
                            <RightSetting :right-id="rc.allSales" :right-model="roleRights" disabled="true"></RightSetting>
                            <p></p>
                            <RightSetting :edit="true" :right-id="rc.deleteReceipt" :right-model="roleRights" disabled="true"></RightSetting>
                            <RightSetting :edit="true" :right-id="rc.createNegativeReceipt" :right-model="roleRights" disabled="true"></RightSetting>
                            <RightSetting :edit="true" :right-id="rc.updateBill" :right-model="roleRights" disabled="true"></RightSetting>
                            <RightSetting :edit="true" :right-id="rc.addDiscount" :right-model="roleRights" disabled="true"></RightSetting>
                            <RightSetting :edit="true" :right-id="rc.orders" :right-model="roleRights" disabled="true"></RightSetting>
                            <RightSetting :edit="true" :right-id="rc.createCustomer" :right-model="roleRights" disabled="true"></RightSetting>
                            <RightSetting :edit="true" :right-id="rc.updateCustomer" :right-model="roleRights" disabled="true"></RightSetting>
                            <RightSetting :edit="true" :right-id="rc.updateReceipt" :right-model="roleRights" disabled="true"></RightSetting>
                            <p></p>
                            <RightSetting :edit="true" :right-id="rc.cashRegisterSettings" :right-model="roleRights" disabled="true"></RightSetting>
                            <RightSetting :edit="true" :right-id="rc.salesItem" :right-model="roleRights" disabled="true"></RightSetting>
                            <RightSetting :edit="true" :right-id="rc.companySettings" :right-model="roleRights" disabled="true"></RightSetting>
                          </div>
                        </div>
                      </div>
                      <div class="mb-4"></div>
                      <div class="col-12 col-lg-6 mt-2 mb-2">
                        <div class="e-inner-card shadow-sm e-rounding">
                          <div class="card-header e-user__header">
                        <span>
                     {{ $t('rights.office') }}
                  </span>
                          </div>
                          <div class="card-body py-5 px-4">
                            <RightSetting :right-id="rc.allReceipts" :right-model="roleRights" disabled="true"></RightSetting>
                            <RightSetting :right-id="rc.allSales" :right-model="roleRights" disabled="true"></RightSetting>
                            <RightSetting :right-id="rc.exportSales" :right-model="roleRights" disabled="true"></RightSetting>
                            <RightSetting :right-id="rc.allSubjects" :right-model="roleRights" disabled="true"></RightSetting>
                            <p></p>
                            <RightSetting :edit="true" :right-id="rc.orders" :right-model="roleRights" disabled="true"></RightSetting>
                            <RightSetting :edit="true" :right-id="rc.stock" :right-model="roleRights" disabled="true"></RightSetting>
                            <RightSetting :edit="true" :right-id="rc.salesItem" :right-model="roleRights" disabled="true"></RightSetting>
                            <RightSetting :edit="true" :right-id="rc.companySettings" :right-model="roleRights" disabled="true"></RightSetting>
                            <RightSetting :edit="true" :right-id="rc.loyaltyPoints" :right-model="roleRights" disabled="true"></RightSetting>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </form>
              <div class="d-flex flex-wrap-reverse justify-content-between pt-3">
                <div>
                  <button v-if="user.userId !== null" @click="removeUser(user.userId)" class="btn btn-danger mr-4">
                    {{ $t('button.deleteUser')}}
                  </button>
                </div>

                <div class="e-btn-mobile-container">
                <button @click="showUser = false" class="btn btn-outline-secondary mr-3">
                  {{ $t('button.back')}}
                </button>
                <button v-if="user.userId === null" @click="createUser()" class="btn btn-primary">
                  {{ $t('button.createUser')}}
                </button>
                <button v-else @click="editUser()" class="btn btn-primary">
                  {{ $t('button.save') }}
                </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
    import Loader from "@/components/Loader"
    import PremiumBanner from "@/components/PremiumBanner";
    import RightSetting from "@/components/util/RightSetting.vue";
    import rightUtil from "@/util/rights";

    export default {
        name: 'Users',
        components: { Loader, PremiumBanner,RightSetting },

        data: function () {
            return {
                users: [],
                user: {
                  userId: null,
                  userName: '',
                  email: '',
                  role: 'user',
                  rights: []
                },
                roles: ['none','temp','user','accountant','custom','admin'],
                rolesCreate: ['temp','user','accountant','custom','admin'],
                loading: true,
                showUser: false,
                rc: rightUtil.codes,
                roleRights: [],
                showRightDetails: false
            }
        },

        mounted: function () {
            this.refresh();
        },

        methods: {
            refresh: function() {
                const vm = this;
                vm.loading = true;
                this.$http.post('/user/get-user-list')
                    .then(function (response) {
                        vm.loading = false;
                        vm.users = response.data.users;
                    });
            },
            getRoleName: function(role) {
                return this.$t('role.'+role);
            },
          prepareAddUser: function () {
            this.clearUser();
            this.showUser = true;
          },
          prepareEditUser: function (userId) {
            const vm = this;
            vm.loading = true;
            this.$http.post('/user/get-user',{userId:userId})
                .then(function (response) {
                  vm.loading = false;
                  vm.user = response.data;
                  vm.showUser = true;

                  vm.readRoleRights(vm.user.role);
                });
          },
          editUser: function () {
            const vm = this;
            this.$http.post('/user/update-user',{
              userId: vm.user.userId,
              userName: vm.user.userName,
              email: vm.user.email,
              role: vm.user.role,
              rights: vm.user.rights
            })
                .then(function (response) {
                  vm.showUser = false;
                  vm.refresh();
                  if(response.data.confirmEmailSent === true) {
                    vm.$modal.cs_alert(vm.$t('message.confirmationEmail'));
                  }
                });
          },
          clearUser : function() {
              this.user = {
                  userId: null,
                  userName: '',
                  email: '',
                  role: 'user',
                  rights: []
              }
              this.readRoleRights(this.user.role);
              this.showRightDetails = false;
          },
          createUser: function() {
            const vm = this;
            this.$http.post('/user/add-new-user',{
              userName: vm.user.userName,
              email: vm.user.email,
              role: vm.user.role,
              rights: vm.user.rights
            })
                .then(function () {
                  vm.refresh();
                  vm.showUser = false;
                  vm.$modal.cs_alert(vm.$t('dialog.createUser') + ' ' + vm.user.email);
                });
          },
          isActualUser: function(userId) {
              return localStorage.userId === userId;
          },
          rightChanged: function (data) {
              const index = this.user.rights.indexOf(data.rightId);
              if(index!==-1) {
                this.user.rights.splice(index,1);
              }
              if(data.present === true) {
                this.user.rights.push(data.rightId);
              }
          },
          readRoleRights: function(role) {
            const vm = this;
            this.$http.post('/user/get-role-rights',{
              role: role,
            })
                .then(function (response) {
                  vm.roleRights = response.data.roleRights;
                });
          },
          roleIconSvg: function(role) {
            const svgs = {
              admin: `<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="22" cy="15" r="9" fill="#1e3d7a"/>
                <circle cx="22" cy="15" r="6" fill="#dde8f8"/>
                <path d="M6 39c0-8.837 7.163-16 16-16s16 7.163 16 16" fill="#1e3d7a"/>
                <circle cx="37" cy="35" r="9" fill="#1e3d7a"/>
                <circle cx="37" cy="35" r="5.5" fill="none" stroke="#dde8f8" stroke-width="1.5"/>
                <circle cx="37" cy="35" r="2" fill="#dde8f8"/>
                <rect x="36.2" y="27.5" width="1.6" height="3" rx="0.8" fill="#dde8f8"/>
                <rect x="36.2" y="41.5" width="1.6" height="3" rx="0.8" fill="#dde8f8"/>
                <rect x="29.5" y="34.2" width="3" height="1.6" rx="0.8" fill="#dde8f8"/>
                <rect x="43.5" y="34.2" width="3" height="1.6" rx="0.8" fill="#dde8f8"/>
                <rect x="31.5" y="29.5" width="3" height="1.6" rx="0.8" fill="#dde8f8" transform="rotate(45 33 30.3)"/>
                <rect x="41.5" y="39.5" width="3" height="1.6" rx="0.8" fill="#dde8f8" transform="rotate(45 43 40.3)"/>
                <rect x="31.5" y="39.5" width="3" height="1.6" rx="0.8" fill="#dde8f8" transform="rotate(-45 33 40.3)"/>
                <rect x="41.5" y="29.5" width="3" height="1.6" rx="0.8" fill="#dde8f8" transform="rotate(-45 43 30.3)"/>
              </svg>`,
              user: `<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="24" cy="16" r="9" fill="#1e3d7a"/>
                <circle cx="24" cy="16" r="6" fill="#dde8f8"/>
                <path d="M8 40c0-8.837 7.163-16 16-16s16 7.163 16 16" fill="#1e3d7a"/>
              </svg>`,
              accountant: `<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="24" cy="15" r="9" fill="#1e3d7a"/>
                <circle cx="24" cy="15" r="6" fill="#dde8f8"/>
                <path d="M8 39c0-8.837 7.163-16 16-16s16 7.163 16 16" fill="#1e3d7a"/>
                <rect x="28" y="28" width="14" height="14" rx="3" fill="#3a6abf"/>
                <rect x="30" y="31" width="4" height="2" rx="0.5" fill="#dde8f8"/>
                <rect x="36" y="31" width="4" height="2" rx="0.5" fill="#dde8f8"/>
                <rect x="30" y="35" width="4" height="2" rx="0.5" fill="#dde8f8"/>
                <rect x="36" y="35" width="4" height="2" rx="0.5" fill="#4caf50"/>
              </svg>`,
              temp: `<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="24" cy="15" r="9" fill="#1e3d7a"/>
                <circle cx="24" cy="15" r="6" fill="#dde8f8"/>
                <path d="M8 39c0-8.837 7.163-16 16-16s16 7.163 16 16" fill="#1e3d7a"/>
                <circle cx="36" cy="36" r="8" fill="#3a6abf"/>
                <rect x="35" y="30" width="2" height="5" rx="1" fill="#dde8f8"/>
                <rect x="35" y="36" width="4" height="2" rx="1" fill="#dde8f8"/>
              </svg>`,
              custom: `<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="24" cy="15" r="9" fill="#1e3d7a"/>
                <circle cx="24" cy="15" r="6" fill="#dde8f8"/>
                <path d="M8 39c0-8.837 7.163-16 16-16s16 7.163 16 16" fill="#1e3d7a"/>
                <circle cx="36" cy="36" r="8" fill="#3a6abf"/>
                <rect x="35" y="30" width="2" height="12" rx="1" fill="white"/>
                <rect x="30" y="35" width="12" height="2" rx="1" fill="white"/>
              </svg>`,
              none: `<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="24" cy="16" r="9" fill="#aaa"/>
                <circle cx="24" cy="16" r="6" fill="#e0e0e0"/>
                <path d="M8 40c0-8.837 7.163-16 16-16s16 7.163 16 16" fill="#aaa"/>
                <line x1="14" y1="14" x2="34" y2="34" stroke="#e53935" stroke-width="3" stroke-linecap="round"/>
                <line x1="34" y1="14" x2="14" y2="34" stroke="#e53935" stroke-width="3" stroke-linecap="round"/>
              </svg>`,
            };
            return svgs[role] || svgs['user'];
          },
          removeUser: function (userId) {
            this.$modal.cs_confirm(this.$t('confirm.deleteUser'),()=>{
              const vm = this;
              vm.loading = true;
              this.$http.post('/user/delete-user', {userId: userId})
                  .then(function () {
                    vm.loading = false;
                    vm.showUser = false;
                    vm.refresh();
                  },function() {
                    vm.loading = false;
                    vm.showUser = false;
                  });
            });
          }
        }
    }

</script>

<style>
  .user-card {
    background: #fff;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  .user-card--inactive {
    opacity: 0.6;
  }

  .user-card__banner {
    background: #f0f0f0;
    color: #212529;
    padding: 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 16px;
    border-bottom: 1px solid #e0e0e0;
  }
  .user-card__banner--inactive {
    background: #f8f8f8;
    color: #aaa;
  }
  .user-card__banner--admin {
    background: #dde8f8;
  }
  .user-card__role-icon {
    width: 64px;
    height: 64px;
    min-width: 64px;
    background: rgba(0,0,0,0.07);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    padding: 10px;
  }
  .user-card__role-icon svg {
    width: 100%;
    height: 100%;
  }
  .user-card__banner-text {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
    min-width: 0;
  }
  .user-card__role-label {
    font-size: 0.8rem;
    color: #666;
    margin-bottom: 2px;
  }
  .user-card__name {
    font-size: 1.2rem;
    font-weight: 600;
    margin-bottom: 6px;
  }
  .user-card__badges .badge {
    font-size: 0.8rem;
    padding: 4px 10px;
  }

  .user-card__body {
    padding: 16px 20px 14px;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .user-card__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px 20px;
    margin-bottom: 14px;
  }
  .user-card__label {
    font-weight: 600;
    font-size: .9rem;
    margin-bottom: 2px;
  }
  .user-card__value {
    margin-bottom: 0;
    font-size: 0.9rem;
    word-break: break-all;
  }
  .user-card__field--wide {
    grid-column: span 2;
  }

  .user-card__actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    border-top: 1px solid #f0f0f0;
    padding-top: 12px;
  }

  @media (max-width: 576px) {
    .user-card__banner {
      padding: 14px;
      gap: 12px;
    }
    .user-card__role-icon {
      width: 52px;
      height: 52px;
      min-width: 52px;
    }
    .user-card__body {
      padding: 14px 14px 12px;
    }
    .user-card__grid {
      grid-template-columns: 1fr;
    }
    .user-card__field--wide {
      grid-column: span 1;
    }
  }
</style>